var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicle-search pa-10"},[_c('title-page',{attrs:{"icon":"mdi-car"}},[_vm._v(" "+_vm._s(_vm.$t('menu.vehicles'))+" ")]),_c('v-row',{staticClass:"mt-5"},[_c('v-col',[_c('vehicle-list',{attrs:{"exportable":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }